import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import { Application } from 'app/models/dto/deal-application.model';
import { Deal } from 'app/models/dto/deal.model';
import { Offer } from 'app/services/offers/offer.model';
import {
  DealApplicationQuestionRequirement
} from 'app/store/deal/deal-application-requirements/deal-application-requirement.state';
import { Approval } from 'ng2-app/models/dto/approval/approval.model';
import { OfferOption } from 'ng2-app/models/dto/offer-option/offer-option.model';
import { LenderUserState } from 'ng2-app/store/lender-user/lender-user/lender-user.state';
import { ApprovalsState } from 'ng2-app/store/offers/approvals.state';

@Component({
  selector: 'app-deal',
  templateUrl: './deal.component.html',
  styleUrls: ['./deal.component.scss']
})
export class DealComponent implements OnChanges {

  @Input() approvals: Approval[] = [];
  @Input() offerOptions: OfferOption[] = [];
  @Input() bulkSubmitting = false;
  @Input() deal: Deal;
  @Input() offers: Offer[];
  @Input() questions: DealApplicationQuestionRequirement | null;
  @Input() applications: Application[];
  @Input() appQuestionsLoading: boolean;
  @Input() hasSignedApplication: boolean;
  @Input() canReactivateDeals: boolean;
  @Input() questionRequirementsMet: boolean;
  @Input() dateSigned: string;
  @Input() readOnly: boolean = false;
  @Input() showDealRightColumn: boolean = true;
  @Input() hasContractRequest: boolean = false;

  @Output() appComplete = new EventEmitter();
  @Output() submit = new EventEmitter<boolean>();

  approvalsLoading = this.store.selectSignal( ApprovalsState.loading );

  canSeeFunctionalApprovals = this.store.selectSignal( LenderUserState.hasPermission('PL:functionalApprovals.read') );

  constructor(private store: Store) { }

  ngOnChanges(changes: SimpleChanges): void {
    // if there are changes in any of the values associated with auto-updating deal to appComplete, check to see if status should be updated
    if (changes.hasSignedApplication || changes.dateSigned || changes.questionRequirementsMet || changes.deal) {
      this.updateDealStatusIfNeeded();
    }
  }

  updateDealStatusIfNeeded() {
    const appComplete = ((this.hasSignedApplication || this.dateSigned) && this.questionRequirementsMet);
    if (appComplete && this.deal.status === 'appInProgress') {
      this.appComplete.emit();
    }
  }

  closer() {
    return this.deal.closer ? `${this.deal.closer.first} ${this.deal.closer.last}` : null;
  }
}
